import { type TimelineItem } from 'apps/employer_renewals/components/timeline/Timeline'
import { useEmployerRenewalConfig } from 'apps/employer_renewals/providers/EmployerRenewalConfigProvider'

import ContentLayout, { type InfoSection } from './ContentLayout'

type Props = {
  showBackToDashboardButton?: boolean
}

const finalizedOnlyTimelineItems: TimelineItem[] = [
  {
    title: 'Today',
    body: 'Review your confirmed 2026 cost estimates and adjust your allowance strategy. ',
    isCompleted: true,
  },
  {
    title: 'Nov 5',
    body: 'Open Enrollment begins for 2026. Your employees will be invited to start enrolling in their plans, and coverage will begin Jan 1.',
    isActive: true,
  }
]

const hasPreliminaryQuoteTimelineItems: TimelineItem[] = [
  {
    title: 'Oct 15',
    body: 'Review your estimated 2026 costs and adjust your allowance strategy.',
    isCompleted: true,
  },
  ...finalizedOnlyTimelineItems,
]

const infoSections: InfoSection[] = [
  {
    title: "What's next",
    body: [
      "You've done everything necessary for your health benefits next year! Employees you marked as eligible for benefits will be automatically invited to enroll in insurance plans on Nov 5.",
      'Invited employees may receive enrollment reminders via email and SMS. They can opt out anytime.'
    ],
  },
]

export default function FinalizedContent ({ showBackToDashboardButton }: Props) {
  const { employerRenewalConfig } = useEmployerRenewalConfig()

  const timelineItems = employerRenewalConfig?.has_accepted_preliminary_quote ? hasPreliminaryQuoteTimelineItems : finalizedOnlyTimelineItems

  return (
    <ContentLayout
      timelineItems={timelineItems}
      infoSections={infoSections}
      showBackToDashboardButton={showBackToDashboardButton}
    />
  )
}
